import request from "@/util/axios";

export const auth_wechat_token_login_by_code = (code) => {
  const grant_type = "wechat";
  return request({
    url: "/v5/weixin-token", // /v5/weixin-token // /auth/wechat/token
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "post",
    params: { grant_type, code, type: "mp" },
  });
};

export const mall_wx_get_user_info = () => {
  return request({
    url: "/mall/wx/wx-user-get-user-info",
    method: "post",
  });
};

// 取当前客户配置值（configName 以 h5./adm. 开头可免后端白名单）
export const wx_user_get_config_value = (configName) => {
  return request({
    url: "/wx/wx-user-get-config-value",
    params: { configName },
    method: "post",
  }).then(res => res.data);
};
